import styled, { keyframes, css } from 'styled-components';

const slideAnimation = keyframes `
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const NotificationWrapper = styled.div `
  align-items: flex-end;
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: 16px;
  position: fixed;
  z-index: 21;
  right: 0;

  ${props => props.position === 'center' &&
    css `
      right: 50%;
      transform: translateX(50%);
    `}

  ${props => props.position === 'left' &&
    css `
      right: auto;
      left: 0;
    `}

  ${props => { var _a; return (_a = props.styles) === null || _a === void 0 ? void 0 : _a.call(props, props); }};
`;
const Notification = styled.div `
  align-items: center;
  animation: ${slideAnimation} 1s ease-out;
  background: ${props => props.theme.colors.background[props.backgroundColor]};
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  padding: 16px;
  width: fit-content;

  > svg {
    height: 18px;
    width: 18px;
  }

  button {
    margin-left: 8px;
    padding: 4px;

    svg {
      margin: 0;
    }
  }

  ${props => { var _a; return (_a = props.styles) === null || _a === void 0 ? void 0 : _a.call(props, props); }};
`;

export { Notification, NotificationWrapper };
